import { AuthenticationContainer } from "entities/Authentication";
import { Button, Error, Flex, Typography } from "shared/_ui";
import styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { StatusPageProps } from "../../lib/StatusPageProps";

function isTelegramWebApp() {
    // eslint-disable-next-line
    // @ts-ignore
    return typeof TelegramWebviewProxy !== 'undefined';
  }

const Fail: React.FC<StatusPageProps> = ({returnLink}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const page_content = 
    <Flex className={styles.wrapper} direction="column" align="center">
        <Error className={styles.icon}/>
        <Typography.Title className={styles.heading} level={1}>
            {t('banner.failedPayment.heading')}
        </Typography.Title>
    </Flex>

    const web_page = 
    <AuthenticationContainer 
        footer = {
            <Button type='primary' onClick={()=>{navigate(returnLink)}}>
                {t('banner.successfulPayment.button')}
            </Button>
        }>
        {page_content}
    </AuthenticationContainer>

    const frame_page = <div className={styles.framewrapper}>{page_content}</div>

    return (returnLink && !isTelegramWebApp()) ? web_page : frame_page;
}

export { Fail };